import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { motion } from "framer-motion";
import { SEOHead } from "@/components/SEOHead";

const TusDatos = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Tus Datos son Tuyos — Política de No Venta de Datos | CreceLocal"
        description="Tus datos son tuyos. Nunca los venderemos. Descubrí cómo protegemos la información de tus clientes y garantizamos la privacidad en nuestra plataforma."
        canonical="/tus-datos"
      />
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-[800px]">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="prose prose-invert prose-sm sm:prose-base md:prose-lg max-w-none"
          >
            <h1 className="text-4xl md:text-5xl font-medium tracking-tight mb-8 text-foreground">
              Tus datos son tuyos
            </h1>

            <p className="text-muted-foreground mb-12">
              <strong>CreceLocal LLC</strong>
              <br />
              Última actualización: junio 2025
            </p>

            <div className="space-y-12 text-muted-foreground">
              <section>
                <p className="text-xl font-medium text-foreground">
                  No vendemos tus datos. Nunca.
                </p>
                <p className="mt-4">
                  Tampoco los alquilamos, los cedemos ni los usamos para fines
                  distintos a los de operar el servicio que contrataste.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  Qué hacemos con tu información
                </h2>
                <p className="mb-4">Usamos tus datos únicamente para:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Mantener tu cuenta funcionando</li>
                  <li>Procesar tus pagos</li>
                  <li>Enviarte información relacionada con el servicio</li>
                  <li>Responderte cuando nos escribís</li>
                </ul>
                <p className="mt-4 font-medium text-foreground">Nada más.</p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  Los datos de tus clientes también son tuyos
                </h2>
                <p>
                  Cuando cargás contactos, conversaciones o cualquier
                  información de tus clientes en la plataforma, esos datos
                  siguen siendo tuyos. Nosotros los procesamos en tu nombre para
                  que el sistema funcione — y solo para eso.
                </p>
                <p className="mt-4">
                  Si cancelás tu cuenta, podés solicitar la exportación de tus
                  datos antes de que los eliminemos.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  Con quién compartimos información
                </h2>
                <p>
                  Solo con los servicios que necesitamos para que la plataforma
                  funcione — procesadores de pago, infraestructura tecnológica y
                  las plataformas que integramos (Meta, Google, WhatsApp
                  Business API). Todos bajo acuerdos de confidencialidad y con
                  el único fin de operar el servicio.
                </p>
                <p className="mt-4 font-medium text-foreground">
                  Con nadie más.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  Están seguros
                </h2>
                <p>
                  Usamos cifrado, accesos restringidos y buenas prácticas de
                  seguridad para proteger tu información. Ningún sistema es
                  infalible, pero hacemos todo lo que está a nuestro alcance
                  para que tus datos estén protegidos.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  Tus derechos
                </h2>
                <p className="mb-4">Podés pedirme en cualquier momento:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Ver qué información tenemos sobre vos</li>
                  <li>Corregir algo que esté mal</li>
                  <li>Eliminar tus datos</li>
                  <li>Llevarte tus datos a otro servicio</li>
                </ul>
                <p className="mt-4">
                  Escribinos a info@crecelocal.com y lo resolvemos.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-medium text-foreground mb-4">
                  Preguntas
                </h2>
                <p>info@crecelocal.com</p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TusDatos;
